export const dialysisData = [
  {
    label: "Indio",
    name: "dialysisIndio",
    address: "Kidney Institute of the Desert - Indio",
  },
  {
    label: "Rancho Mirage",
    name: "dialysisRanchoMirage",
    address: "Kidney Institute at Eisenhower Medical Center",
  },
  {
    label: "La Quinta",
    name: "dialysisLaQuinta",
    address: "La Quinta Kidney Center",
  },
  {
    label: "Coachella",
    name: "dialysisCoachella",
    address: "Coachella Kidney Institute",
  },
];

export const nephrologyData = [
  {
    label: "Indio",
    name: "nephrologyIndio",
    address: "Coachella Valley Nephrology - Indio",
  },

  {
    label: "La Quinta",
    name: "nephrologyLaQuinta",
    address: "La Quinta Kidney Center",
  },
];
